/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 21.05.17.
 */

import _ from "underscore";

export function queryParse(queryString) {
    if (queryString == null) return {};
    let result = {};
    let expressions = queryString.split("&");
    for (let e of expressions) {
        let paramAndValue = e.split("=", 2);
        let param = decodeURIComponent(paramAndValue[0]);
        let value = null;
        if (paramAndValue.length > 1) value = decodeURIComponent(paramAndValue[1]);
        result[param] = value;
    }
    return result;
}

export function queryMake(queryObject) {
    let result = [];
    for (let e of _.keys(queryObject)) {
        let param = encodeURIComponent(e);
        let value = encodeURIComponent(queryObject[e]);
        if (value == null) value = "";
        result.push(param + "=" + value);
    }
    return result.join("&");
}

export function nvl(value, value2) {
    if (value == null) return value2;
    return value;
}

/**
 * Convert value to string.
 * @param {Object} value Some value
 * @returns {string} Value converted to string. If value was null or undefined then returns empty string.
 */
export function strvalue(value) {
    if (value == null) return "";
    return value.toString();
}

/**
 * Convert value to string and strip leading and trailing spaces
 * @param {Object} value Value
 * @returns {string} Value converted to string.
 */
export function stripstrvalue(value) {
    return strvalue(value).trim();
}

/**
 * Converts ISO-formatted datetime string to Date object
 * @param {string} value
 * @returns {Date} Converted date object. If string was null then returns null.
 */
export function datevalue(value) {
    if (value == null) return null;
    let d = new Date(value);
    return d;
}

/**
 * Makes deep clone of object. It is user responsibility to assure that there are no circular references.
 * @param {Object} value
 * @returns {Object}
 */
export function deepClone(value) {
    if (value == null) return value;

    if (_.isArray(value)) {
        return _.map(value, deepClone);
    } else if (_.isObject(value)) {
        return _.mapObject(value, deepClone);
    } else {
        return value;
    }
}

export function isArguments(object) {
    return Object.prototype.toString.call(object) === "[object Arguments]";
}

/**
 * Compares if two objects are equal
 * @param a
 * @param b
 * @returns {boolean}
 */
export function deepEquals(a, b, ca = [], cb = []) {
    // Partially extracted from node-deeper and adapted to exclude comparison
    // checks for functions.
    // https://github.com/othiym23/node-deeper
    if (a === b) {
        return true;
    } else if (typeof a === "function" || typeof b === "function") {
        // Assume all functions are equivalent
        // see https://github.com/mozilla-services/react-jsonschema-form/issues/255
        return true;
    } else if (typeof a !== "object" || typeof b !== "object") {
        return false;
    } else if (a === null || b === null) {
        return false;
    } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    } else if (a instanceof RegExp && b instanceof RegExp) {
        return (
            a.source === b.source &&
            a.global === b.global &&
            a.multiline === b.multiline &&
            a.lastIndex === b.lastIndex &&
            a.ignoreCase === b.ignoreCase
        );
    } else if (isArguments(a) || isArguments(b)) {
        if (!(isArguments(a) && isArguments(b))) {
            return false;
        }
        let slice = Array.prototype.slice;
        return deepEquals(slice.call(a), slice.call(b), ca, cb);
    } else {
        if (a.constructor !== b.constructor) {
            return false;
        }

        let ka = Object.keys(a);
        let kb = Object.keys(b);
        // don't bother with stack acrobatics if there's nothing there
        if (ka.length === 0 && kb.length === 0) {
            return true;
        }
        if (ka.length !== kb.length) {
            return false;
        }

        let cal = ca.length;
        while (cal--) {
            if (ca[cal] === a) {
                return cb[cal] === b;
            }
        }
        ca.push(a);
        cb.push(b);

        ka.sort();
        kb.sort();
        for (var j = ka.length - 1; j >= 0; j--) {
            if (ka[j] !== kb[j]) {
                return false;
            }
        }

        let key;
        for (let k = ka.length - 1; k >= 0; k--) {
            key = ka[k];
            if (!deepEquals(a[key], b[key], ca, cb)) {
                return false;
            }
        }

        ca.pop();
        cb.pop();

        return true;
    }
}

/**
 * Compares two objects. Objects can be strings, numbers, booleans, arrays of objects or objects with properties
 * @param {Object} a
 * @param {Object} b
 * @returns {number} Returns negative value if a is smaller, positive value if a is greater or 0 if a and b are equal
 */
export function deepCompare(a, b) {
    if (a == null) return (b == null ? 0 : -1);
    else if (b == null) return 1;

    if (_.isString(a)) return a.localeCompare(b);
    else if (_.isNumber(a)) return a - b;
    else if (a instanceof Date) return a.getTime() - b.getTime();
    else if (_.isBoolean(a)) return a ? (b ? 0 : 1) : (b ? -1 : 0);
    else if (_.isArray(a)) {
        let len = Math.min(a.length, b.length);
        for (let i = 0; i < len; i++) {
            let result = deepCompare(a[i], b[i]);
            if (result) return result;
        }
        return a.length - b.length;
    }
    else if (_.isObject(a)) {
        let keysa = _.keys(a);
        keysa.sort();
        for (let k of keysa) {
            let result = deepCompare(a[k], b[k]);
            if (result) return result;
        }
        let keysb = _.keys(b);
        return keysa.length - keysb.length;
    }
    // Convert to string:
    return a.toString().localeCompare(b.toString());
}
